import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  allCoursesLabel: {
    id: 'course-authoring.studio-home.libraries.filters.all-courses.label',
    defaultMessage: 'All courses',
  },
  courseFilterLabel: {
    id: 'course-authoring.studio-home.libraries.filters.course.label',
    defaultMessage: 'Filter by course',
  },
});

export default messages;
